/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { HistoryAlbumKeyedData } from "./Common/HistoryAlbumKeyedData";
import { HistoryAlbumUser } from "./Common/HistoryAlbumUser";

export const protobufPackage = "Reality.Reality.Api";

export interface HistoryAlbumGetRequest {
  vliveId?: string | undefined;
}

/**
 * <string>POST /api/v2/history_album/get</string>
 * 思い出アルバム表示に必要なデータを取得する
 */
export interface HistoryAlbumGetResponse {
  user: HistoryAlbumUser | undefined;
  keyedData: HistoryAlbumKeyedData[];
  highestTotalScoreKey: string;
  highestTotalScore: number;
}

function createBaseHistoryAlbumGetRequest(): HistoryAlbumGetRequest {
  return { vliveId: undefined };
}

export const HistoryAlbumGetRequest = {
  encode(message: HistoryAlbumGetRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.vliveId !== undefined) {
      writer.uint32(10).string(message.vliveId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HistoryAlbumGetRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryAlbumGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.vliveId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryAlbumGetRequest {
    return { vliveId: isSet(object.vliveId) ? globalThis.String(object.vliveId) : undefined };
  },

  toJSON(message: HistoryAlbumGetRequest): unknown {
    const obj: any = {};
    if (message.vliveId !== undefined) {
      obj.vliveId = message.vliveId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HistoryAlbumGetRequest>, I>>(base?: I): HistoryAlbumGetRequest {
    return HistoryAlbumGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HistoryAlbumGetRequest>, I>>(object: I): HistoryAlbumGetRequest {
    const message = createBaseHistoryAlbumGetRequest();
    message.vliveId = object.vliveId ?? undefined;
    return message;
  },
};

function createBaseHistoryAlbumGetResponse(): HistoryAlbumGetResponse {
  return { user: undefined, keyedData: [], highestTotalScoreKey: "", highestTotalScore: 0 };
}

export const HistoryAlbumGetResponse = {
  encode(message: HistoryAlbumGetResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.user !== undefined) {
      HistoryAlbumUser.encode(message.user, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.keyedData) {
      HistoryAlbumKeyedData.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.highestTotalScoreKey !== "") {
      writer.uint32(26).string(message.highestTotalScoreKey);
    }
    if (message.highestTotalScore !== 0) {
      writer.uint32(32).int64(message.highestTotalScore);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HistoryAlbumGetResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryAlbumGetResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.user = HistoryAlbumUser.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.keyedData.push(HistoryAlbumKeyedData.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.highestTotalScoreKey = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.highestTotalScore = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryAlbumGetResponse {
    return {
      user: isSet(object.user) ? HistoryAlbumUser.fromJSON(object.user) : undefined,
      keyedData: globalThis.Array.isArray(object?.keyedData)
        ? object.keyedData.map((e: any) => HistoryAlbumKeyedData.fromJSON(e))
        : [],
      highestTotalScoreKey: isSet(object.highestTotalScoreKey) ? globalThis.String(object.highestTotalScoreKey) : "",
      highestTotalScore: isSet(object.highestTotalScore) ? globalThis.Number(object.highestTotalScore) : 0,
    };
  },

  toJSON(message: HistoryAlbumGetResponse): unknown {
    const obj: any = {};
    if (message.user !== undefined) {
      obj.user = HistoryAlbumUser.toJSON(message.user);
    }
    if (message.keyedData?.length) {
      obj.keyedData = message.keyedData.map((e) => HistoryAlbumKeyedData.toJSON(e));
    }
    if (message.highestTotalScoreKey !== "") {
      obj.highestTotalScoreKey = message.highestTotalScoreKey;
    }
    if (message.highestTotalScore !== 0) {
      obj.highestTotalScore = Math.round(message.highestTotalScore);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HistoryAlbumGetResponse>, I>>(base?: I): HistoryAlbumGetResponse {
    return HistoryAlbumGetResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HistoryAlbumGetResponse>, I>>(object: I): HistoryAlbumGetResponse {
    const message = createBaseHistoryAlbumGetResponse();
    message.user = (object.user !== undefined && object.user !== null)
      ? HistoryAlbumUser.fromPartial(object.user)
      : undefined;
    message.keyedData = object.keyedData?.map((e) => HistoryAlbumKeyedData.fromPartial(e)) || [];
    message.highestTotalScoreKey = object.highestTotalScoreKey ?? "";
    message.highestTotalScore = object.highestTotalScore ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
